<template>
  <div class="table-content">
    <div class="header">
      <div class="headerLeft">
        <!--日期选择-->
        <div class="startDate">
          <el-date-picker v-model="date1" size="small" type="date" @change="getSTime1" placeholder="选择日期"
            :picker-options="getSTime1Fun">
          </el-date-picker>
        </div>
        <!-- <div class="endDate">
          <el-date-picker v-model="date2" size="small" type="date" @change="getSTime2" placeholder="结束日期"
            :picker-options="getSTime2Fun">
          </el-date-picker>
        </div> -->
      </div>
      <div class="fun">
        <el-row>
          <el-button class="search" size="mini" @click="search()">搜索</el-button>
          <el-button class="deltale" size="mini" @click="deltale()">清除</el-button>
          <el-button class="doexcel" size="mini" @click="doexcel()">导出</el-button>
        </el-row>
      </div>
    </div>
    <div class="deadline"> 
      <div>数据截止日期：{{depositDate}}</div>
      <div>单位：万元</div>
    </div>
    <el-table class="loadingPrivate" max-height="500" :data="tableData"
      style="width: 100%,font-size:0.5rem,margin-bottom:1rem">
      <el-table-column prop="deptName" label="三级单位" width="200"> </el-table-column>
      <el-table-column prop="depositTotal" label="累计福利额度" width="200"> </el-table-column>
      <el-table-column prop="depositAdd" label="2022年累计净增" width="200"> </el-table-column>
      <el-table-column prop="depositDayAdd" label="当日净增" width="200"> </el-table-column>
      <!-- <el-table-column prop="jkOpenNumber" label="金科二维码累计开户" width="200"> </el-table-column>
      <el-table-column prop="jkOpenNumberDay" label="金科二维码当日开户" width="200"> </el-table-column>
      <el-table-column prop="ljOpenNumber" label="专属链接累计开户" width="200"> </el-table-column>
      <el-table-column prop="ljOpenNumberDay" label="专属链接当日开户" width="200"> </el-table-column> -->
    </el-table>
    <div class="pagination" v-if="isPage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="currentPage1" :page-size="15" layout=" prev, pager, next" :total="totalCount">
      </el-pagination>
      <div class="pagNum">共{{pagNum}}页 （共{{totalCount}}条）</div>
    </div>
  </div>
</template>
<script>
  import {
    IronTwo,
    CheckOne
  } from "@icon-park/vue"
  export default {
    name: "filialePower2", //中支数据看台
    data() {
      return {
        tableData: [],
        paginations: {
          pageIndex: 1, // 当前位于哪页
          pageSize: 15, // 1页显示多少条
          pageSizes: [5, 10, 15, 20], //每页显示多少条
          layout: "total, sizes, prev, pager, next, jumper" // 翻页属性
        },
        currentPage1: 1,
        date1: '', //开始日期
        date2: '', //结束日期
        isPage: true,
        token: "",
        pagNum: "", //总页数
        pageNumber: 1, //页码数
        pageSize: 15, //每页条数
        totalCount: "", //总条数
        startTime: "", //开始时间
        endTime: "", //结束时间
        selectData: [], //导出excel文件
        excelData: [],
        //请求参数
        req: {
          startTime1: "", //开始时间
          endTime1: "", //结束时间
        },
        //设置日历可选择日期
        getSTime1Fun: {
          disabledDate: (time) => {
            if (this.date2) return time.getTime() > this.date2
            else return
          }
        },
        getSTime2Fun: {
          disabledDate: (time) => {
            if (this.date1) return time.getTime() < this.date1
            else return
          }
        },
        firstStartTime: "", //初始开始时间
        firstEndTime: "", //初始结束时间
        limitSign: "", //用户标识
        depositDate: "", //数据展示截止日期
      }
    },
    components: {
      IronTwo,
      CheckOne,
    },
    props: {},
    created() {
      // this.getYesterDay();
      this.token = sessionStorage.getItem('token');
      console.log("this.aasd", this.token)
      this.limitSign = sessionStorage.getItem("userTag")
      this.firstSearch(); //首次进入页面加载所有数据
      // this.pagNumS()
    },
    mounted() {},
    methods: {
      //获取截止时间（前一天）
      getYesterDay() {
        var time = (new Date).getTime() - 24 * 60 * 60 * 1000;
        var yesterday = new Date(time);
        var year = yesterday.getFullYear();
        var month = yesterday.getMonth() + 1;
        var day = yesterday.getDate();
        this.firstStartTime = year + '/' + month + '/' + day;
        this.firstEndTime = year + '/' + month + '/' + day;
        this.req.startTime1 = year + '/' + month + '/' + day;
        this.req.endTime1 = year + '/' + month + '/' + day;
        console.log("日期", this.firstStartTime);
        console.log("月份", month);
        console.log("日期", day);
      },
      //条数转页数
      pagNumS() {
        let pages = Math.ceil(this.totalCount / 15)
        this.pagNum = pages;
        console.log("aaaa", this.pagNum)
      },
      // 上下分页 pageIndex
      handleCurrentChange(page) {
        let params = {
          depositDate: this.req.startTime1, //开始时间
          // endTime: this.req.endTime1, //结束时间
          token: this.token,
          pageNumber: this.currentPage1,
          pageSize: this.pageSize,
          limitSign: this.limitSign, //用户标识
        };
        console.log("bbbbbbbbb", params)
        let _this = this;
        let url = '/ft-oms/dataReport/selectDeptDayallPlan.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.list
            this.totalCount = parseInt(res.data.data.totalCount)
            this.pagNumS();
          } else if (res.data.code == "99999") {
            if (res.data.data.code == '88886') {
              this.$router.push({
                path: "/login"
              })
            } else {
              this.tableData = [];
              this.isPage = false
            }
          } else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      // 每页多少条切换 pageSize
      handleSizeChange(page_size) {

      },
      //获取开始日期
      getSTime1(val1) {
        this.date1 = val1
        console.log(this.date1)
        var d = new Date(this.date1);
        var dYear = d.getFullYear();
        var dMonth = d.getMonth() + 1;
        var dDay = d.getDate();
        var youWant = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
        console.log(youWant)
        if ((dYear <2022) || (dYear ==2022&&dMonth < 5) || (dYear ==2022&&dMonth == 5&&dDay < 24)) {
          this.$alert('请选择2022/05/24之后的日期作为筛选条件', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        } else {
          this.startTime = youWant
        }
        console.log("this.startTime", this.startTime)
      },
      //获取结束日期
      getSTime2(val2) {
        this.date2 = val2
        var d2 = new Date(this.date2);
        var youWant2 = d2.getFullYear() + '/' + (d2.getMonth() + 1) + '/' + d2.getDate();
        console.log(youWant2)
        if (youWant2 == "1970/1/1") {
          youWant2 = this.firstEndTime
        }
        this.endTime = youWant2
        console.log("this.endTime", this.endTime)
      },
      //首次进入加载数据
      firstSearch() {
        let params = {
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          depositDate: this.firstStartTime, //开始时间
          // endTime: this.firstEndTime, //结束时间
          token: this.token,
          limitSign: this.limitSign, //用户标识
        };
        let _this = this;
        let url = '/ft-oms/dataReport/selectDeptDayallPlan.action'
        this.$http.post(url, params).then(res => {
          if (res.data.code == "200") {
            console.log("data1===", res.data.data)
            this.tableData = res.data.data.list;
            this.totalCount = parseInt(res.data.data.totalCount)
            this.depositDate = res.data.data.depositDate;
            this.pagNumS();
            this.isPage = true
          } else if (res.data.code == "99999") {
            if (res.data.data.code == '88886') {
              this.$router.push({
                path: "/login"
              })
            } else {
              this.tableData = [];
              this.isPage = false
            }
          } else {
            this.tableData = [];
            this.isPage = false
          }
        }, );
      },
      //搜索
      search() {
        if (this.startTime != '') {
          let params = {
            pageNumber: this.pageNumber,
            pageSize: this.pageSize,
            depositDate: this.startTime, //开始时间
            // endTime: this.endTime, //结束时间
            token: this.token,
            limitSign: this.limitSign, //用户标识
          };

          this.req.startTime1 = params.depositDate
          // this.req.endTime1 = params.endTime

          let _this = this;
          let url = '/ft-oms/dataReport/selectDeptDayallPlan.action'
          this.$http.post(url, params).then(res => {
            if (res.data.code == "200") {
              console.log("data1===", res.data.data)
              this.tableData = res.data.data.list
              this.totalCount = parseInt(res.data.data.totalCount)
              this.depositDate = res.data.data.depositDate;
              this.currentPage1 = 1
              this.pagNumS();
              this.isPage = true
            } else if (res.data.code == "99999") {
              if (res.data.data.code == '88886') {
                this.$router.push({
                  path: "/login"
                })
              } else {
                this.tableData = [];
                this.isPage = false
              }
            } else {
              this.tableData = [];
              this.isPage = false
            }
          }, );
        } else {
          this.$alert('请选择2022/05/24之后的日期作为筛选条件', '温馨提示', {
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      },
      //清除
      deltale() {
        this.date1 = "";
        this.date2 = "";
        this.startTime = "";
        this.endTime = "";
      },
      //导出
      doexcel() {
        let params = {
          depositDate: this.req.startTime1, //开始时间
          // endTime: this.req.endTime1, //结束时间
          token: this.token,
          limitSign: this.limitSign, //用户标识
        };
        let _this = this;
        let url = '/ft-oms/dataReport/selectDeptDayallPlanExport.action'
        this.$http.post(url, params, {
          responseType: 'blob'
        }).then(res => {
          if (res.data.code == "99999") {
            if (res.data.data.code == '88886') {
              this.$router.push({
                path: "/login"
              })
            }
          } else {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            }); // res就是接口返回的文件流了
            let objectUrl = URL.createObjectURL(blob);
            window.location.href = objectUrl;
          }
        }, );
      },
    }
  }

</script>

<style scoped>
  body {
    margin: 0;
  }

  .pagination {
    margin-top: 1.2rem;
    display: flex;
    justify-content: center;
    height: 1.8rem;
    font-size: 0.9rem;
    line-height: 1.8rem;

  }

  .header {
    height: 3rem;
    display: flex;
    justify-content: space-between;
  }

  .filiale,
  .input {
    margin-right: 0.5rem;
  }

  .startDate,
  .endDate {
    margin-right: 0.5rem;
  }

  .search {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 0.6rem;
    color: #FF9D47;
  }

  .deltale {
    border: 1px solid #7A7A7A;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 0.6rem;
    color: #7A7A7A;
  }

  .doexcel {
    border: 1px solid #FF9D47;
    border-radius: 0.2rem;
    text-align: center;
    font-size: 0.6rem;
    color: #ffffff;
    background: #FF9D47;
  }

  .pagNum {
    margin-left: 1.2rem;
    margin-top: 0.2rem;
  }

  .checkboxDiv {
    width: 4.8rem;
    display: none;
    border: 1px solid #999999;
    border-top: none;
  }

  .headerLeft {
    display: flex;
  }

  .fun {
    display: flex;
    margin-bottom: 1rem;
    float: right;
  }
  .deadline{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

  .input {
    display: flex;
    border: 1px solid #dedede;
    width: 9rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border-radius: 0.25rem;
    color: #bfcbd9;
  }

  .input input {
    flex: 9;
    border: 0;
    font-size: 0.8rem;
    width: 5rem;
    outline: none;
  }

  .input img {
    width: 50%;
    height: 50%;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    flex: 1;
    margin-top: 0.4rem;
  }

  /*修改input框默认文本样式*/
  input::-webkit-input-placeholder {
    /* placeholder颜色 */
    color: #C1C1C1;
    /* placeholder字体大小 */
  }

  .el-input__inner {
    height: 1.8rem;
    font-size: 0.72rem;
  }

  /*修改日期框样式*/
  .startDate>>>.el-date-editor {
    width: 8rem;
  }

  .startDate>>>.el-input__inner:focus {
    border-color: #FF9D47;
  }

  .endDate>>>.el-date-editor {
    width: 8rem;
  }

  .endDate>>>.el-input__inner:focus {
    border-color: #FF9D47;
  }

  /*修改下拉框样式*/
  .filiale>>>.el-input__inner {
    width: 8rem;
  }

  .filiale>>>.el-select .el-input.is-focus .el-input__inner {
    border-color: #FF9D47;
  }

  .filiale>>>.el-select .el-input__inner:focus {
    border-color: #FF9D47;

  }

  .el-select-dropdown__item.selected {
    color: #FF9D47;
  }

  .el-select-dropdown__item.hover {
    background-color: #ffffff;
  }

  .filiale>>>.el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: #FAF0E7;
    color: #FF9D47;
  }

  /*修改分页样式*/
  .pagination>>>.el-pager li.active {
    color: #FF9D47;
  }

  .pagination>>>.el-pager li:hover {
    color: #FF9D47;
  }

  .pagination>>>.el-icon-arrow-left:hover {
    color: #FF9D47;
  }

  .pagination>>>.el-icon-arrow-right:hover {
    color: #FF9D47;
  }

  .pagination>>>.el-icon-arrow-left.active {
    color: #FF9D47;
  }

  .pagination>>>.el-icon-arrow-right.active {
    color: #FF9D47;
  }

  .el-icon-arrow-left:hover {
    color: #FF9D47;
  }

  .el-icon-arrow-right:hover {
    color: #FF9D47;
  }

  .el-icon-arrow-left.active {
    color: #FF9D47;
  }

  .el-icon-arrow-right.active {
    color: #FF9D47;
  }

  .pagination>>>.el-pagination .btn-next:hover {
    color: #FF9D47;
  }

  .pagination>>>.el-pagination .btn-prev:hover {
    color: #FF9D47;
  }

  /*按钮样式*/
  .doexcel>>>.el-button--default .el-button--mini:hover {
    background-color: #FF9D47 !important;
    color: #ffffff;
    border-color: #FF9D47;
  }

  .search>>>.el-button--default .el-button--mini:hover {
    background-color: #ffffff !important;
    color: #FF9D47;
    border-color: #FF9D47;
  }

  .deltale>>>.el-button--default .el-button--mini:hover {
    background-color: #ffffff !important;
    color: #000;
    border-color: #000;
  }

  /*修改table样式*/
  .table-content>>>.el-table thead.is-group th {
    background-color: #ffffff;
  }

  .table-content>>>.el-table .cell {
    text-align: center;
  }

  .table-content>>>.el-table thead.is-group tr:first-child th:nth-child(2) {
    background: #ffaec9;
  }

  .table-content>>>.el-table thead.is-group tr:first-child th:nth-child(3) {
    background: #ffc90e;
  }

  .table-content>>>.el-table thead.is-group tr:nth-child(3) .is-leaf:nth-child(1) {
    color: #909399;
  }

  .table-content>>>.el-table thead.is-group .is-leaf:nth-child(3) {
    color: #909399;
    background-color: #ffffff;
  }

  .filiale>>>.el-select-dropdown__wrap {
    max-height: 295px;
  }

</style>



// WEBPACK FOOTER //
// filialePower2.vue?5462c554